import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import './Plan.css';
import { signInWithRedirect } from 'aws-amplify/auth';

const clientId = 'S2_87abff03f5e54b65adc372409700311a';

const priceTable = {
  monthly: { free: 0, basic: 20000, pro: 50000 },
  yearly: { free: 0, basic: 200000, pro: 500000 }
};
const displayPriceTable = {
  monthly: { free: '무료', basic: '20,000원', pro: '50,000원' },
  yearly: { free: '무료', basic: '200,000원', pro: '500,000원' },
};
const plans = [
  { name: 'Free', title: '무료 플랜', description: '가장 간단한 기본 기능을 무료로 제공합니다.\n- 핵심 워크플로우 체험\n- AI 검색 1일 3회 제한\n- 1:1 문의 지원 없음\n- 소량 사용량 제약' },
  { name: 'Basic', title: '베이직 플랜', description: '일상적인 업무 자동화를 위한 충분한 기능!\n- 워크플로우 + AI 쿼리 분석\n- 1:1 온라인 문의 지원\n- 월간 사용량 여유' },
  { name: 'Pro', title: '프로 플랜', description: '기업/고급 유저를 위한 모든 기능 제공!\n- 모든 유료 워크플로우\n- AI 분석 무제한\n- 프리미엄 지원(빠른 응답)\n- 시행착오 없는 최적화 제공' }
];
const paymentLabels = [
  { key: 'card', label: '카드결제' },
  { key: 'bank', label: '계좌이체' },
  { key: 'kakaopay', label: '카카오페이' },
  { key: 'cellphone', label: '모바일' }
];
// eslint-disable-next-line no-unused-vars
const webhooks = {
  card: 'https://bshong-n8n.ngrok.io/webhook/nicepay-creditcard-test',
  bank: 'https://bshong-n8n.ngrok.io/webhook/nicepay-accounttrans-test',
  kakaopay: 'https://bshong-n8n.ngrok.io/webhook/nicepay-virtualaccount-test',
  cellphone: 'https://bshong-n8n.ngrok.io/webhook/nicepay-mobile-test',
};
function generateOrderId() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const h = date.getHours().toString().padStart(2, '0');
  const m = date.getMinutes().toString().padStart(2, '0');
  const s = date.getSeconds().toString().padStart(2, '0');
  const rand = Math.random().toString(36).substring(2, 8);
  return `ORDER-${year}${month}${day}-${h}${m}${s}-${rand}`;
}

// Plan 컴포넌트 정의; user를 반드시 props로 전달받아 사용
const Plan = ({ user, currentPlan }) => {
  const [period, setPeriod] = useState('monthly');
  const [modal, setModal] = useState({open: false, plan: null});
  const [resultModal, setResultModal] = useState(false);

  // currentPlan 상태에 따라 플랜 현황 안내
  useEffect(() => {
    if (currentPlan) {
      if (currentPlan === 'free') console.log('[Plan] 현재 플랜: 무료 플랜');
      else if (currentPlan === 'basic') console.log('[Plan] 현재 플랜: 베이직 플랜');
      else if (currentPlan === 'pro') console.log('[Plan] 현재 플랜: 프로 플랜');
      else console.log('[Plan] 현재 플랜(unknown):', currentPlan);
    } else {
      console.log('[Plan] currentPlan 값 없음');
    }
  }, [currentPlan]);

  // 결제 콜백
  const handlePayment = (planName, paymentKey) => {
    const nicePayMethod = paymentKey;
    const price = priceTable[period][planName.toLowerCase()];
    const goodsName = `${planName} 플랜 (${period === 'monthly' ? '월간' : '연간'})`;
    const returnUrl = "https://ez5negsg7b.execute-api.ap-northeast-2.amazonaws.com/prod/payment-approve";
    if (!window.AUTHNICE) {
      alert('결제 연동 스크립트가 로드되지 않았습니다. 새로고침 후 시도 또는 관리자에게 문의하세요.');
      return;
    }
    window.AUTHNICE.requestPay({
      clientId: clientId,
      method: nicePayMethod,
      orderId: generateOrderId(),
      amount: price,
      goodsName: goodsName,
      returnUrl: returnUrl,
      fnError: function (result) {
        setResultModal({success: false, message: result.errorMsg});
      },
    });
    setModal({open: false, plan: null});
  };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Offer',
    name: 'FLOWTO.ai 구독 플랜',
    description: 'Free, Basic, Pro 플랜으로 비즈니스 자동화를 시작하세요',
    offers: {
      '@type': 'AggregateOffer',
      offerCount: 3,
      lowPrice: '0',
      highPrice: '50000',
      priceCurrency: 'KRW',
      offers: [
        {
          '@type': 'Offer',
          name: '무료 플랜',
          price: '0',
          priceCurrency: 'KRW'
        },
        {
          '@type': 'Offer',
          name: '베이직 플랜',
          price: '20000',
          priceCurrency: 'KRW'
        },
        {
          '@type': 'Offer',
          name: '프로 플랜',
          price: '50000',
          priceCurrency: 'KRW'
        }
      ]
    }
  };

  return (
    <div className="plan-page">
      <SEO
        title="구독 플랜"
        description="Free, Basic, Pro 플랜으로 비즈니스 자동화를 시작하세요"
        url="/plan"
        type="website"
        structuredData={structuredData}
      />
      <h1>이용 플랜 안내</h1>
      <div className="plan-toggle-row">
        <button
          className={`plan-toggle-btn${period === 'monthly' ? ' active' : ''}`}
          onClick={() => setPeriod('monthly')}
        >
          Monthly
        </button>
        <button
          className={`plan-toggle-btn${period === 'yearly' ? ' active' : ''}`}
          onClick={() => setPeriod('yearly')}
        >
          Yearly
        </button>
      </div>
      <div className="plan-list">
        {plans.map(plan => {
          const planKey = plan.name.toLowerCase();
          const displayPrice = displayPriceTable[period][planKey];
          // eslint-disable-next-line no-unused-vars
          const price = priceTable[period][planKey];
          const isCurrent = currentPlan === planKey;
          return (
            <div className={`plan-card plan-${planKey}`} key={plan.name}>
              <h2>{plan.title}</h2>
              <div className="plan-price">{displayPrice}
                <span className="plan-period">{planKey === 'free' ? '' : (period === 'monthly' ? '/월' : '/년')}</span>
              </div>
              <pre>{plan.description}</pre>
              {/* 구매 버튼 또는 구독중 안내 */}
              {(planKey === 'basic' || planKey === 'pro') && (
                isCurrent ? (
                  <div
                    style={{
                      marginTop: '16px',
                      borderRadius: '6px',
                      color: '#e67e22', // 더 눈에 띄는 오렌지 계열로 변경
                      textAlign: 'center',
                      padding: '11px 0',
                      fontWeight: 600,
                      letterSpacing: '0.02em',
                      fontSize: '1.06em',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '7px'
                    }}
                  >
                    <span role="img" aria-label="구독중">⭐</span>
                    현재 구독중인 Plan
                  </div>
                ) : (
                  <button
                    type="button"
                    className="plan-buy-btn"
                    onClick={() => {
                      if (!user) {
                        signInWithRedirect({ provider: 'Google' });
                        return;
                      }
                      setModal({ open: true, plan: planKey });
                    }}
                  >
                    구매하기
                  </button>
                )
              )}
              {planKey === 'free' && isCurrent && (
                <div style={{marginTop: '16px', borderRadius:'6px', color:'#e67e22', textAlign:'center', fontWeight:600, fontSize:'1.06em', padding:'11px 0', display:'flex', alignItems:'center', justifyContent:'center', gap:'7px'}}>
                  <span role="img" aria-label="구독중">⭐</span>
                  현재 무료 플랜 이용중입니다
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* 결제 선택 모달 */}
      {modal.open && (
        <div className="plan-modal-bg">
          <div className="plan-modal">
            <div className="plan-modal-title">결제 방식을 선택하세요</div>
            <div className="plan-modal-body">
              {paymentLabels.map(method => (
                <button key={method.key} className="plan-modal-method-btn" onClick={()=>handlePayment(modal.plan, method.key)}>
                  {method.label}
                </button>
              ))}
            </div>
            <button className="plan-modal-close" onClick={()=>setModal({open: false, plan: null})}>취소</button>
          </div>
        </div>
      )}
      {/* 결제 결과 안내 모달 */}
      {resultModal && (
        <div className="plan-modal-bg">
          <div className="plan-modal">
            <div className="plan-modal-title">
              {resultModal.success ? '결제 안내' : '결제 실패'}
            </div>
            <div className="plan-modal-body" style={{minHeight:'60px'}}>
              <div>
                {resultModal.success ? (
                  <>
                    결제 및 승인 결과는 관리자 확인 후 서비스 내역에 반영됩니다.<br/>
                    <span style={{fontSize:'0.95em', color:'#888'}}>문제가 발생했으면 고객센터로 문의해 주세요.</span>
                  </>
                ) : (
                  <>
                    결제 실패: {resultModal.message}
                  </>
                )}
              </div>
            </div>
            <button className="plan-modal-method-btn" onClick={() => { setResultModal(false); window.location.assign('/'); }}>메인으로 돌아가기</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Plan;
